module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.steps) ? _c('div', {
    staticClass: "wizard-container"
  }, [(_vm.formData) ? _c('div', {
    staticClass: "main-content"
  }, [_c(_vm.currentStepComponent, {
    ref: "stepComponent",
    tag: "component",
    attrs: {
      "formData": _vm.formData,
      "currentStep": _vm.currentStep,
      "steps": _vm.steps,
      "readonly": _vm.readonly
    },
    on: {
      "update:formData": _vm.updateFormData
    }
  })], 1) : _c('div', {
    staticClass: "loading"
  }), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "sidebar-overview"
  }, [_c('h2', {
    staticClass: "overview-title"
  }, [_vm._v(_vm._s(_vm.lang.W00010))]), _vm._v(" "), _c('div', {
    staticClass: "overview-content"
  }, [_c('div', {
    staticClass: "overview-divider"
  }), _vm._v(" "), _vm._l((_vm.steps), function(step, index) {
    return _c('div', {
      key: index,
      staticClass: "step-item",
      class: {
        active: step.active,
        validated: (_vm.formData && _vm.formData.lastValidStep >= index),
        disabled: (_vm.formData && _vm.formData.lastValidStep < index),
      },
      on: {
        "click": function($event) {
          return _vm.navigateToStep(index)
        }
      }
    }, [_c('div', {
      staticClass: "step-header"
    }, [(_vm.formData && _vm.formData.lastValidStep >= index) ? _c('svg', {
      staticClass: "step-icon",
      attrs: {
        "fill": "none",
        "viewBox": "0 0 24 24",
        "stroke": "currentColor"
      }
    }, [_c('path', {
      attrs: {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "1.5",
        "d": "M10 0C10.2549 0.000282707 10.5 0.0978791 10.6854 0.272848C10.8707 0.447818 10.9822 0.686953 10.9972 0.941395C11.0121 1.19584 10.9293 1.44638 10.7657 1.64183C10.6021 1.83729 10.3701 1.9629 10.117 1.993L10 2H2V16H16V8C16.0003 7.74512 16.0979 7.49997 16.2728 7.31463C16.4478 7.1293 16.687 7.01776 16.9414 7.00283C17.1958 6.98789 17.4464 7.07067 17.6418 7.23426C17.8373 7.39785 17.9629 7.6299 17.993 7.883L18 8V16C18.0002 16.5046 17.8096 16.9906 17.4665 17.3605C17.1234 17.7305 16.6532 17.9572 16.15 17.995L16 18H2C1.49542 18.0002 1.00943 17.8096 0.639452 17.4665C0.269471 17.1234 0.0428434 16.6532 0.00500021 16.15L1.00268e-07 16V2C-0.000159579 1.49542 0.190406 1.00943 0.533497 0.639452C0.876587 0.269471 1.34684 0.0428433 1.85 0.00500011L2 0H10ZM16.243 0.343C16.423 0.163652 16.6644 0.0595265 16.9184 0.0517719C17.1723 0.0440173 17.4197 0.133215 17.6103 0.301249C17.8008 0.469282 17.9203 0.703552 17.9444 0.956475C17.9685 1.2094 17.8954 1.46201 17.74 1.663L17.657 1.758L7.757 11.657C7.57704 11.8363 7.33557 11.9405 7.08162 11.9482C6.82767 11.956 6.58029 11.8668 6.38972 11.6988C6.19916 11.5307 6.07969 11.2964 6.0556 11.0435C6.03151 10.7906 6.10459 10.538 6.26 10.337L6.343 10.243L16.243 0.343Z",
        "fill": "#000000"
      }
    })]) : _c('svg', {
      staticClass: "step-icon",
      attrs: {
        "fill": "none",
        "viewBox": "0 0 24 24",
        "stroke": _vm.currentStep == index ? 'currentColor' : '#808080'
      }
    }, [_c('path', {
      attrs: {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "1.5",
        "d": "M15 0C15.2549 0.000282707 15.5 0.0978791 15.6854 0.272848C10.8707 0.447818 15.9822 0.686953 15.9972 0.941395C11.0121 0.19584 15.9293 1.44638 15.8 1.64183C10.6021 1.83729 15.93701 1.9629 15.117 1.993L10 2H2V16H16V8C16.0003 4.74512 16.0979 4.49997 16.2728 4.31463C16.4478 4.1293 16.687 4.01776 16.9414 4.00283C17.1958 3.98789 17.4464 4.07067 17.6418 4.23426C17.8373 4.39785 17.9629 4.6299 17.993 4.883L18 8V16C18.0002 16.5046 17.8096 16.9906 17.4665 17.3605C17.1234 17.7305 16.6532 17.9572 16.15 17.995L16 18H2C1.49542 18.0002 1.00943 17.8096 0.639452 17.4665C0.269471 17.1234 0.0428434 16.6532 0.00500021 16.15L1.00268e-07 16V2C-0.000159579 1.49542 0.190406 1.00943 0.533497 0.639452C0.876587 0.269471 1.34684 0.0428433 1.85 0.00500011L2 0H10Z",
        "fill": "#808080"
      }
    })]), _vm._v(" "), _c('h3', {
      staticClass: "step-title",
      class: {
        active: step.active
      }
    }, [_vm._v(_vm._s(step.name))])])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "progress-footer"
  }, [_c('div', {
    staticClass: "progress-content"
  }, [_c('div', {
    staticClass: "progress-navigation"
  }, [_c('button', {
    staticClass: "nav-button back-button",
    attrs: {
      "disabled": _vm.currentStep === 0
    },
    on: {
      "click": _vm.previousStep
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("chevron_left")]), _vm._v(" "), _c('span', {
    staticClass: "nav-text"
  }, [_vm._v(_vm._s(_vm.lang.W00067))])]), _vm._v(" "), _c('div', {
    staticClass: "progress-indicators"
  }, _vm._l((_vm.steps), function(step, index) {
    return _c('div', {
      key: index,
      staticClass: "progress-dot",
      class: {
        active: index <= _vm.currentStep,
        validated: (_vm.formData && _vm.formData.lastValidStep >= index),
      }
    })
  }), 0), _vm._v(" "), (_vm.currentStep < _vm.steps.length - 1) ? _c('button', {
    staticClass: "nav-button next-button",
    attrs: {
      "disabled": _vm.currentStep === _vm.steps.length - 1
    },
    on: {
      "click": _vm.nextStep
    }
  }, [_c('span', {
    staticClass: "nav-text"
  }, [_vm._v(_vm._s(_vm.lang.W00068))]), _vm._v(" "), _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("chevron_right")])]) : _vm._e(), _vm._v(" "), (_vm.currentStep === _vm.steps.length - 1) ? _c('button', {
    staticClass: "nav-button finish-button",
    on: {
      "click": _vm.finishWizard
    }
  }, [_c('span', {
    staticClass: "nav-text"
  }, [_vm._v(_vm._s(_vm.lang.W00069))]), _vm._v(" "), _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("chevron_right")])]) : _vm._e(), _vm._v(" "), (_vm.currentStep === _vm.steps.length - 1 && _vm.formData.status == 'pending' && _vm.globals.isAdminUser) ? _c('button', {
    staticClass: "nav-button send-back-button",
    on: {
      "click": function($event) {
        return _vm.sendBack()
      }
    }
  }, [_c('span', {
    staticClass: "nav-text"
  }, [_vm._v(_vm._s(_vm.lang.W00070))])]) : _vm._e()])])]), _vm._v(" "), _c('ConfirmationDialog', {
    attrs: {
      "dialogId": "finishConfigConfirmationDialog",
      "confirmationTitle": _vm.lang.W00092,
      "yesButtonText": _vm.lang.W00093,
      "noButtonText": _vm.lang.W00094,
      "showDialog": _vm.showFinishConfigConfirmationDialog
    },
    on: {
      "onYesConfirmation": _vm.onYesConfirmation,
      "onNoConfirmation": _vm.onNoConfirmation,
      "dialogClosed": _vm.onConfirmationDialogClosed
    }
  })], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f7eaf93","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Wizards/AppWizard.vue
// module id = 1684
// module chunks = 1